"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withContext = exports.pickContext = exports.default = exports.contextKeys = exports.DefaultContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _en_us = require("./locale/en_us");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DefaultContext = {
  locale: {
    months: _en_us.months,
    weekdays: _en_us.weekdays
  },
  prefixCls: 'zr-cal',
  components: {},
  monthBeforeYear: true,
  onlyValidYear: true,
  onlyValidDecade: true,
  onChangeWhenPrevNextClick: true,
  disabledPrevNextClickWhenDisabled: true
};
exports.DefaultContext = DefaultContext;
var contextKeys = Object.keys(DefaultContext);
exports.contextKeys = contextKeys;
var CalendarContext = /*#__PURE__*/(0, _react.createContext)(DefaultContext);
var _default = CalendarContext;
exports.default = _default;

var pickContext = function pickContext(obj) {
  var rest = _objectSpread({}, obj);

  var context = {};
  contextKeys.forEach(function (key) {
    if (key in rest) {
      context[key] = rest[key];
      delete rest[key];
    }
  });
  return [context, rest];
};

exports.pickContext = pickContext;

var withContext = function withContext(Component) {
  var ComponentWithContext = function ComponentWithContext(props) {
    var _pickContext = pickContext(props),
        _pickContext2 = (0, _slicedToArray2.default)(_pickContext, 2),
        context = _pickContext2[0],
        rest = _pickContext2[1];

    var inheritContext = (0, _react.useContext)(CalendarContext);
    var finalContext = (0, _react.useMemo)(function () {
      return _objectSpread(_objectSpread(_objectSpread({}, DefaultContext), inheritContext), context);
    }, [context, inheritContext]);
    return /*#__PURE__*/_react.default.createElement(CalendarContext.Provider, {
      value: finalContext
    }, /*#__PURE__*/_react.default.createElement(Component, rest));
  };

  return /*#__PURE__*/(0, _react.memo)(ComponentWithContext);
};

exports.withContext = withContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@z-r/calendar/lib/CalendarContext.js
// module id = 1217
// module chunks = 6 7 17 18